__turbopack_context__.v({
  "cardImages": "cardGroup-module-scss-module__QREK3q__cardImages",
  "cardImgWrapper": "cardGroup-module-scss-module__QREK3q__cardImgWrapper",
});
